// Filename: Router.js
define('sentient/aba/router',[
    'jquery',
    'underscore',
    'backbone',
    'loglevel',
    'domReady',
    './app'
], function($, _, Backbone, log, domReady, app) {
    log.trace('running Router.js');
    var Router = Backbone.Router.extend({
        initialize: function() {},
        routes: {
            'exercise-paused': 'pause',
            'console': 'console',
            'session-restore': 'sessionRestore',
            // Default
            '': 'empty',
            '*actions': 'defaultAction'
        },
        empty: function() {
            //log.debug('router:empty action');

        },
        pause: function() {
            log.debug('router:pause', arguments);
            app.session.trigger('pause');
        },
        console: function() {
            log.debug('trigger("show-console")');
            domReady(function(document) {
                $('.sentient-aba').trigger('show-console');
                //app.router.navigate("",{trigger: false});
            });
        },
        sessionRestore: function() {
            domReady(function(document) {
                $('.sentient-aba').trigger('hide-console');

                app.sessionView.updateViewDimensions();

                app.router.navigate('', {
                    trigger: false
                });
                app.windowView.trigger('resize-check');
            });
        },
        defaultAction: function() {
            log.debug('router:defaultAction', arguments);
        }
    });
    //log.debug('Router', Router);
    return Router;
});
